const { default: axiosInstance } = require("utils/axios");

const getListByCustomerCar = async (filter) => {
  try {
    const response = await axiosInstance.get(
      "/car-order-customer/get-order-customer",
      {
        params: filter,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching get list by customer car list:", error);
    throw error;
  }
};

const getListByCustomerCarById = async (id) => {
  try {
    const response = await axiosInstance.get(
      `/car-order-customer/get-order-customer/${id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching get list by customer car by ID:", error);
    throw error;
  }
};

const deleteOrder = async (order_id) => {
  try {
    const response = await axiosInstance.put(
      `/car-order-customer/move-bin/${order_id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting car order :", error);
    throw error;
  }
};

const getListBinCars = async (filter) => {
  try {
    const response = await axiosInstance.get(
      "/car-order-customer/get-order-trash",
      {
        params: {
          ...filter,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching bin car list:", error);
    throw error;
  }
};

const putRecoverOrderFromTrash = async (order_id) => {
  try {
    const response = await axiosInstance.put(
      `/car-order-customer/recover-order/${order_id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting car order :", error);
    throw error;
  }
};

const ListByCustomerCarService = {
  getListByCustomerCar,
  deleteOrder,
  getListBinCars,
  getListByCustomerCarById,
  putRecoverOrderFromTrash,
};
export default ListByCustomerCarService;
